module.exports = __webpack_public_path__ + "static/media/zhubo.08f9c789.png";